<div class="container" style="background-color: #fff;  min-height:600px; margin-top: 10px;">
  <form [formGroup]="profileForm" (ngSubmit)="updateProfile()" >
    <div class="form-group col-md-6" >
      <label style="margin-top: 10px;">First Name</label>
      <input class="form-control" formControlName="firstName">
    </div>

    <div class="form-group mt-2 col-md-6">
      <label>Last Name</label>
      <input class="form-control" formControlName="lastName">
    </div>

    <div class="form-group mt-2 col-md-6">
      <label>Phone Number</label>
      <input class="form-control" formControlName="phoneNumber" (input)="clearProfileUpdateError()">
      <div *ngIf="profileForm.controls.phoneNumber.invalid && profileForm.controls.phoneNumber.touched" class="text-danger">
        Enter a valid 10-digit phone number
      </div>
      <div *ngIf="profileUpdateError" class="text-danger">
        {{profileUpdateError}}
      </div>
    </div>

    <div class="mt-3">
      <button class="btn btn-primary me-2 pop-up-btn-blue" type="button" *ngIf="!isEditMode" (click)="toggleEdit()">Edit</button>
      <button class="btn btn-success" type="submit" *ngIf="isEditMode" [disabled]="isLoading || profileForm.invalid">
        {{ isLoading ? 'Saving...' : 'Save' }}
      </button>
      <button class="btn btn-secondary ms-2" type="button" *ngIf="isEditMode" (click)="toggleEdit()">Cancel</button>
    </div>
  </form>
</div>
